<div class="knowledge-centre-selection__container rounded padding-m">
    <h4 class="margin-bottom-m">{{ title }}</h4>

    @for (article of articles; track $index) {
        <a
            class="knowledge-centre-selection__container__article"
            [href]="article.path"
            [class.margin-bottom-m]="!$last"
        >
            <nw-highlight-card>
                <div
                    role="body"
                    class="knowledge-centre-selection__container__article__body"
                >
                    <p
                        class="knowledge-centre-selection__container__article__body__label margin-right-m"
                    >
                        {{ article.label }}
                    </p>
                    <nw-icon
                        class="knowledge-centre-selection__container__article__body__icon"
                        icon="chevron-right"
                    ></nw-icon>
                </div>
            </nw-highlight-card>
        </a>
    }
</div>
